import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'nexus_cookie_consent';

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    // Show the banner only if the user hasn't made a choice yet
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        // Small delay for mount animation
        const timer = setTimeout(() => setVisible(true), 400);
        return () => clearTimeout(timer);
      }
    } catch {
      // localStorage unavailable — show banner anyway
      const timer = setTimeout(() => setVisible(true), 400);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'all');
    } catch {
      // ignore storage errors
    }
    setClosing(true);
    setTimeout(() => setVisible(false), 300);
  };

  const acceptEssential = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'essential');
    } catch {
      // ignore storage errors
    }
    setClosing(true);
    setTimeout(() => setVisible(false), 300);
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-[9990] px-4 md:px-6 transition-all duration-500 ${
        closing ? 'opacity-0 translate-y-6' : 'opacity-100 translate-y-0'
      }`}
    >
      <div
        className="max-w-5xl mx-auto mb-4 md:mb-6 rounded-2xl overflow-hidden"
        style={{
          background: 'linear-gradient(145deg, #001a1c 0%, #002a2e 70%, #001a1c 100%)',
          border: '1px solid rgba(0,197,200,0.35)',
          boxShadow: '0 8px 40px rgba(0,0,0,0.45)',
        }}
      >
        <div className="p-5 md:p-6">
          <div className="flex items-start gap-4">
            {/* Icon */}
            <div
              className="hidden sm:flex w-11 h-11 shrink-0 rounded-xl items-center justify-center"
              style={{ background: 'rgba(0,197,200,0.14)', border: '1px solid rgba(0,197,200,0.35)' }}
            >
              <i className="ri-shield-check-line text-[#00C5C8] text-xl" />
            </div>

            {/* Text */}
            <div className="flex-1 min-w-0">
              <p className="text-white font-semibold text-sm md:text-base mb-1.5">
                Sua privacidade importa para nós
              </p>
              <p className="text-white/70 text-xs md:text-sm leading-relaxed">
                Utilizamos cookies e tecnologias semelhantes para melhorar sua
                experiência, analisar a navegação e personalizar conteúdos. Ao
                clicar em <span className="text-white/90 font-medium">"Aceitar todos"</span>,
                você concorda com o uso de todos os cookies. Em{' '}
                <span className="text-white/90 font-medium">"Apenas essenciais"</span>,
                mantemos somente os indispensáveis ao funcionamento do site. Saiba
                mais em nossa{' '}
                <Link
                  to="/politica-de-privacidade"
                  className="font-medium underline underline-offset-2 hover:opacity-80 whitespace-nowrap"
                  style={{ color: '#00C5C8' }}
                >
                  Política de Privacidade
                </Link>
                .
              </p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end gap-2.5 mt-4 md:mt-5">
            <button
              onClick={acceptEssential}
              className="px-5 py-2.5 rounded-lg text-sm font-semibold cursor-pointer whitespace-nowrap transition-all duration-200 hover:opacity-90"
              style={{
                background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.18)',
                color: 'rgba(255,255,255,0.85)',
              }}
            >
              Apenas essenciais
            </button>
            <button
              onClick={acceptAll}
              className="px-6 py-2.5 rounded-lg text-sm font-semibold cursor-pointer whitespace-nowrap transition-all duration-200 hover:opacity-90"
              style={{ background: '#00C5C8', color: '#001416' }}
            >
              Aceitar todos
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}